export const urls = {
  root: '/',
  enterPhoneNumber: '/enter-phone-number',
  customerDetails: '/customer-details',
  emailVerification: '/email-verification',
  chooseYourPlan: '/choose-your-plan',
  paymentDetails: '/payment-details',
  agreement: '/agreement',
  review: '/review',
  thanks: '/thanks',
  document: '/document',
  ratesAndTerms: 'https://sunbit.com/rates_and_terms/',
};

export const pagesNames = {
  enterPhoneNumber: 'enter-phone-number',
  customerDetails: 'customer-details',
  emailVerification: 'email-verification',
  chooseYourPlan: 'choose-your-plan',
  paymentDetails: 'payment-details',
  agreement: 'agreement',
  review: 'review',
  thanks: 'thanks',
  document: 'document',
  ratesAndTerms: 'ratesAndTerms',
};
